require('../../vendor/psagroupeuk/theme/resources/theme/psagroupe/js/theme');
